import {
  Loaders,
  createUseLoad,
  createLoaderObject,
  GetLoadParamMap,
  GetLoadResultMap,
  loadersAsMutations,
} from 'entities/hooks/load';

import { userLoaders } from './users';
import { authLoaders } from './auth';
import { teamLoaders } from './teams';
import { officeLoaders } from './offices';
import { projectLoaders } from './projects';
import { clientLoaders } from './clients';
import { invoiceLoaders } from './invoice';
import { outsourceProviderLoaders } from './outsourceProviders';
import { notificationLoaders } from './notification';
import { infraLoaders } from './infra';
import { generalLoaders } from './general';
import { uploadLoaders } from './uploads';
import { feedbackLoaders } from './feedback';
import { createMutationHookObject } from 'entities/hooks';

// enforce intellisense and permission <> key
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function buildLoaders<AppLoaders extends Record<string, Loaders<any>>>(
  loaders: AppLoaders,
): AppLoaders {
  return loaders;
}

export const entityLoaders = buildLoaders({
  auth: authLoaders,

  teams: teamLoaders,

  users: userLoaders,

  offices: officeLoaders,

  projects: projectLoaders,

  clients: clientLoaders,

  invoice: invoiceLoaders,

  outsourceProviders: outsourceProviderLoaders,

  notifications: notificationLoaders,

  infra: infraLoaders,

  general: generalLoaders,

  uploads: uploadLoaders,

  feedback: feedbackLoaders,
});

export type EntityLoaders = typeof entityLoaders;

export const useLoad = createUseLoad(entityLoaders);

export const loaders = createLoaderObject(entityLoaders, useLoad);

export type LoadParams = GetLoadParamMap<EntityLoaders>;

export type LoadResults = GetLoadResultMap<EntityLoaders>;

export const loadActions = createMutationHookObject(loadersAsMutations(entityLoaders));
